<template>
  <div class="px-5 py-4">
    <h1>
      <span style="color: #707842">Play</span><span style="color: #d13633">Day</span>
      <img
        src="https://www.playday.be/images/playday.png"
        height="55px"
        style="display: inline; margin-top: -5px"
      />
    </h1>
    <p>
      Al onze communicatie in verband met activiteiten gaat via
      <a class="navbar-brand" href="https://www.playday.be/" style="color: rgba(35, 35, 35, 0.8)"
        ><img
          src="https://www.playday.be/images/playday.png"
          width="30px"
          style="display: inline; margin-top: -5px"
        />
        PlayDay</a
      >
    </p>

    <p>Meld je zeker aan om aan alle activiteiten te kunnen deelnemen!</p>
    <p class="mt-5"></p>
    <h1>
      <span class="insta_title pr-3">Instagram</span>
      <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" color="#1749da" />
    </h1>
    Wil je zeker op de hoogte blijven van alle
    <span class="font-bold">EJV PEPER</span> nieuwtjes? Volg ons dan ook zeker op
    <a class="px-2" href="https://instagram.com/ejv_peper"
      >instagram
      <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" />
    </a>
    !
    <p>Meld je zeker aan om aan alle activiteiten te kunnen deelnemen!</p>
    <p class="mt-5"></p>
    <h1>Inschrijven voor tienkamp</h1>
    <div>
      <p>
        Schrijf je via <a href="https://forms.gle/6opeoeUCn7ynLUjo6">deze link</a> in voor onze
        startactivitiet!
      </p>
      <!-- <form
        style="position: relative"
        action="https://martijndriesen.me/inschrijvingTienkamp.php"
        method="GET"
      >
        <form-input id="name" text="Naam" type="input"></form-input>
        <form-input id="first_name" text="Voornaam" type="input"></form-input>
        <form-input
          id="email_ouder"
          text="Emailadres ouders"
          type="input"
        ></form-input>
        <form-input id="gsm_ouder" text="GSM ouder" type="input"></form-input>
        <form-input
          id="email_tiener"
          text="Emailadres tiener"
          type="input"
        ></form-input>
        <form-input id="gsm_tiener" text="GSM tiener" type="input"></form-input>
        <form-input
          id="dob"
          text="Geboortedatum"
          type="date"
          min="2003-01-01"
          max="2008-12-31"
        ></form-input>
        <form-input
          type="text"
          id="opmerkingen"
          text="Opmerkingen"
        ></form-input>
        <form-input
          type="file"
          id="medische_fiche"
          text="Medische fiche"
        ></form-input>
-->
      <p>
        <a href="/Medische_fiche_NAAM_VOORNAAM.docx"> Download het in te vullen medische fiche!</a>
      </p>
      <!--
        <form-submit value="Schrijf je in!"></form-submit>
        <div class="shock">
          <img
            src="/images/shock.jpg"
            alt=""
            height="150px"
            style="transform: scaleX(-1)"
          />
        </div>
      </form> -->
      <div></div>
    </div>
  </div>
</template>

<script>
// import FormInput from '@/components/form/FormInput.vue';
// import FormSubmit from '@/components/form/FormSubmit.vue';

export default {
  name: 'contact',
  components: {
    // 'form-input': FormInput,
    // 'form-select': FormSelect,
    // 'form-submit': FormSubmit,
  },
};
</script>

<style lang="scss" scoped>
.insta_title {
  color: transparent;
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
  background: -webkit-radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
  background-clip: text;
  -webkit-background-clip: text;
}

.shock {
  position: absolute;
  z-index: -100;
  bottom: -20px;
  right: 0px;
}
</style>
